module.exports = __webpack_public_path__ + "assets/img/sh12.b9652a81.jpg";